import {
  GET_ACTIVE_WATER_QUALITY,
  GET_ALL_WATER_QUALITY,
  GET_WATER_QUALITY_BY_ID,
  CREATE_WATER_QUALITY,
  UPDATE_WATER_QUALITY,
  DELETE_WATER_QUALITY,
  UPLOAD_WATER_QUALITY_DOCUMENT,
  CLEAR_WATER_QUALITY,
  WATER_QUALITY_ERROR,
} from "../actions/types";

const initialState = {
  activeWaterQuality: null,
  allWaterQuality: [],
  currentWaterQuality: null,
  loading: true,
  error: {},
  assetPath: ""
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ACTIVE_WATER_QUALITY:
      return {
        ...state,
        activeWaterQuality: payload.data.waterQuality,
        loading: false,
      };
    case GET_ALL_WATER_QUALITY:
      return {
        ...state,
        allWaterQuality: payload.data.waterQuality,
        assetPath: payload.data.assetPath,
        loading: false,
      };
    case GET_WATER_QUALITY_BY_ID:
      return {
        ...state,
        currentWaterQuality: payload.data,
        loading: false,
      };
    case CREATE_WATER_QUALITY:
      return {
        ...state,
        allWaterQuality: [payload.data, ...state.allWaterQuality],
        loading: false,
      };
    case UPDATE_WATER_QUALITY:
      return {
        ...state,
        allWaterQuality: state.allWaterQuality.map((item) =>
          item._id === payload.data._id ? payload.data : item
        ),
        currentWaterQuality: payload.data,
        loading: false,
      };
    case DELETE_WATER_QUALITY:
      return {
        ...state,
        allWaterQuality: state.allWaterQuality.filter(
          (item) => item._id !== payload
        ),
        loading: false,
      };
    case UPLOAD_WATER_QUALITY_DOCUMENT:
      return {
        ...state,
        currentWaterQuality: payload.data,
        allWaterQuality: state.allWaterQuality.map((item) =>
          item._id === payload.data._id ? payload.data : item
        ),
        loading: false,
      };
    case CLEAR_WATER_QUALITY:
      return {
        ...state,
        activeWaterQuality: null,
        allWaterQuality: [],
        currentWaterQuality: null,
        loading: true,
        error: {},
      };
    case WATER_QUALITY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
